import axios from 'axios'
import JwtService from '@/core/services/jwt.service'
import router from './router'

/**
 * Service to call HTTP request via Axios
 */
const API_URL = process.env.VUE_APP_API_URL ?? 'https://admin.tumar.com'

axios.defaults.baseURL = API_URL + '/api'
axios.defaults.headers.common[
  'Authorization'
] = `Bearer ${JwtService.getToken()}`

axios.interceptors.request.use(
  (config) => {
    const token = JwtService.getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    } else {
      config.params = {
        ...config.params,
        country_iso_code: localStorage.getItem('country_iso_code'),
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response.status === 401) {
      JwtService.destroyToken()

      if (
        error.config.url.includes('login') ||
        error.config.url.includes('/frontend/order/retail')
      ) {
        return Promise.reject(error)
      }
      router.push({ name: 'login' })
    }

    return Promise.reject(error)
  }
)

export default axios
